import type { RouteObject } from 'react-router';

import { OtpVerifyPage } from './OtpVerify';

/**
 * `/login/verify` — one `RouteObject`, so the file is `.route.tsx` singular.
 *
 * The URL nests under `/login` because the step does, but the route is a
 * sibling rather than a child: there is no shared layout element between them,
 * and the code screen's own guard is the location state the sign-in screen
 * handed it, not a loader.
 */
export const otpVerifyRoute: RouteObject = {
  path: '/login/verify',
  element: <OtpVerifyPage />,
};
